import { Injectable } from '@angular/core';
import { EnrichmentAccordion, EnrichmentAccordionElement } from 'src/app/models/EnrichmentCollapse';
import { ODDetailResponse } from 'src/app/models/OpenData.ODDetailResponse';
import { DOCUMENT_NAMES_TO_REMOVE } from 'src/app/shared/constants/card-documents.constants';

@Injectable({
    providedIn: 'root'
})
export class CardRequestDetailDocumentsService {

    documentNames: string[] = [];
    enrichmentAccordion: EnrichmentAccordion[] = [];
    activedAccordionItems: number[] = [];

    setDocumentNames(response: ODDetailResponse): void {
        this.documentNames = [];
        for (const key in response.documents) {
            this.documentNames.push(key);
        }

        for (const key in response.data) {
            if (!this.documentNames.includes(key)) {
                this.documentNames.splice(this.documentNames.length - 1 , 0, key);
            }
        }

        this.documentNames = this.documentNames.filter(doc => !DOCUMENT_NAMES_TO_REMOVE.includes(doc));
    }

    addFeasibilityEnrichmentDataToAccordion(title: string, feasibilityInfo: Record<string, any>): void {
        const elements: EnrichmentAccordionElement[] = [];
        for (const key in feasibilityInfo) {
            elements.push({ key: key, value: feasibilityInfo[key] });
        }
        this.enrichmentAccordion.push({ title: title, elements: elements });
    }

    cleanFeasibilityEnrichmentData(): void {
        this.enrichmentAccordion = [];
    }

    onTabOpen(index: number): void {
        if (!this.activedAccordionItems.includes(index)) {
            this.activedAccordionItems.push(index);
        }
    }

    onTabClose(index: number): void {
        this.activedAccordionItems = this.activedAccordionItems.filter(i => i !== index);
    }

    expandAll(): void {
        this.activedAccordionItems = this.enrichmentAccordion.map((_, index) => index);
    }

    colapseAll(): void {
        this.activedAccordionItems = [];
    }
}
